import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { COLORS, Spinner } from '@podiumhq/design-system';
import useChangeStep from 'hooks/useChangeStep';

const LOADING_INTERVAL = 1500;

const CreatingAccountLoading = () => {
  const changeStep = useChangeStep();

  useEffect(() => {
    const timer = setInterval(() => {
      changeStep('/trials/profile');
    }, LOADING_INTERVAL);

    return () => clearInterval(timer);
  }, [changeStep]);

  return (
    <Wrapper>
      <Content>
        <LoadingIcon>
          <Spinner size="lg" color="black.lightest" />
        </LoadingIcon>
        <LoadingText>Perfect, we’re creating your Podium account.</LoadingText>
      </Content>
    </Wrapper>
  );
};

const Content = styled.div`
  width: 345px;
  margin-right: auto;
  margin-left: auto;
  padding-top: 35vh;
  height: 65vh;
  position: relative;
`;

const Wrapper = styled.div`
  height: 100vh;
  background-color: #12151a;
`;

const LoadingText = styled.p`
  font-size: 24px;
  font-weight: 500;
  line-height: 150%;
  color: ${COLORS.silver.lighter};
  text-align: center;
`;

const LoadingIcon = styled.div`
  height: 64px;
  width: 64px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 32px;
`;

export default CreatingAccountLoading;
